import type { TOC } from '@ember/component/template-only'
import { colspanMax } from 'teacher-ui-client/modifiers/colspan-max'
import type { ComprehensionProgressLessonEvent } from 'teacher-ui-client/reporting/ui-scope/rex/dashboard/student/index/route'
import { formatDate, t } from 'ember-intl'
import { ThStandard } from 'teacher-ui-client/components/th/standard'

interface Args {
  isLoading?: boolean
  eventsData: ComprehensionProgressLessonEvent[]
}

interface Signature {
  Args: Args
  Element: HTMLTableElement
}

export const ComprehensionProgressEvents: TOC<Signature> = <template>
  <table class="divide-oceany-blue-150 border-oceany-blue-150 divide-y border-b" ...attributes>
    <thead>
      <tr>
        <ThStandard class="w-40">
          {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.date"}}
        </ThStandard>
        <ThStandard>
          {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.lessonName"}}
        </ThStandard>
        <ThStandard>
          {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.score"}}
        </ThStandard>
        <ThStandard>
          {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.numberOfAttempts"}}
        </ThStandard>
      </tr>
    </thead>
    <tbody class="divide-oceany-blue-150 divide-y {{if @isLoading 'opacity-50'}}">
      {{#each @eventsData as |event|}}
        <tr>
          <td class="p-3">{{formatDate event.created_at day="2-digit" month="short" year="numeric"}}</td>
          <td class="p-3">
            {{t
              "components.reporting.tables.readingEggspress.dashboardStudent.lessonEventRow"
              number=event.lesson
              name=event.lesson_name
            }}
          </td>
          <td class="p-3">{{event.score}}%</td>
          <td class="p-3">{{event.number_of_attempts}}</td>
        </tr>
      {{else}}
        <tr>
          <td data-test-empty-message class="p-3 text-center italic" {{colspanMax}}>
            {{t "components.reporting.tables.readingEggspress.dashboardStudent.eventsEmptyMessage"}}
          </td>
        </tr>
      {{/each}}
    </tbody>
  </table>
</template>

export default ComprehensionProgressEvents
